"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storyDataState = exports.storyCreateFileState = void 0;
const recoil_1 = require("recoil");
//!파일은 따로 관리
exports.storyCreateFileState = (0, recoil_1.atom)({
    key: 'storyCreateFile',
    default: null,
});
exports.storyDataState = (0, recoil_1.atom)({
    key: 'storyDataState',
    default: {
        id: '',
        title: '',
        thumbnail: null,
        category_id: '',
        public_status: 0,
        auth_status: 0,
        closed: false,
    },
});
